module.exports = __webpack_public_path__ + "img/cup-2.3041dd0c.png";